import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Role } from '@xanadu/model';
import { PickerComponent } from '../picker/picker.component';
import { RoleCache } from '@xanadu/cache';

@Component({
    selector: 'app-role-picker',
    templateUrl: './role-picker.component.html',
    styleUrls: ['./role-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RolePickerComponent extends PickerComponent<Role> {
    private readonly roleCache = inject(RoleCache);

    constructor() {
        super();

        effect(() => {
            const roles = this.roleCache.signal();

            if (roles) {
                this.items.set([...roles.values()]);
            }
        });
    }

    protected filter(_: Role): boolean {
        return true;
    }
}
